import { EMSConfig, ModuleGridType } from 'types/global'
import type { BasicAccessorConfig } from './types'

const DEFAULT_SLOPE_DEGREES_FOR_EMS = 15

const setter = ({ moduleGrid, value }: { moduleGrid: ModuleGridType; value: EMSConfig | null }) => {
  const commands: Command[] = []
  const currentEMSConfig = moduleGrid.getEMSConfig()

  // it's important to set the slope of the panels first
  // THEN set the emsConfig
  // this is so that the elevation of the module grid
  // can be properly set, as it's measured from the lowest point of the module grid
  // closest to the ground, which can change with the slope
  if (!!value && !currentEMSConfig) {
    const setSlopeCommand = new window.SetPanelConfigurationCommand(
      moduleGrid,
      'slope',
      DEFAULT_SLOPE_DEGREES_FOR_EMS,
      window.Utils.generateCommandUUIDOrUseGlobal()
    )
    commands.push(setSlopeCommand)
  }

  const setEMSConfigCommand = new window.SetEMSConfigCommand(moduleGrid, value)
  commands.push(setEMSConfigCommand)

  const multiCommand = new window.MultiCmdsCommand(commands)
  window.editor.execute(multiCommand)
}

const getter = (moduleGrid: ModuleGridType): EMSConfig | null => {
  return moduleGrid.getEMSConfig()
}

export const emsConfigAccessorConfig: BasicAccessorConfig<EMSConfig | null> = {
  get: getter,
  set: setter,
}
